module.exports = __webpack_public_path__ + "static/media/fresh mozarella.69c724c0.png";